// // import React, { useState, useEffect } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import config from "../../Common/Configurations/APIConfig";
// // import apiService from "../../Common/Configurations/APIService";
// // import Header from "../../Common/Layout/Header";
// // import { useAuth } from "../../Common/Configurations/AuthContext";
// // import moment from "moment";

// // const BookingAccounting = () => {
// //   const { bookingId } = useParams();
// //   const { user } = useAuth();
// //   const navigate = useNavigate();

// //   const [loading, setLoading] = useState(true);
// //   const [invoices, setInvoices] = useState([]);
// //   const [ledgers, setLedgers] = useState([]);

// //   const fetchAccountingData = async () => {
// //     setLoading(true);
// //     try {
// //       // Fetch Invoices and Ledgers in parallel
// //       const [invRes, ledRes] = await Promise.all([
// //         apiService.get(`${config.GETMONGOINVOICEBYID}/${bookingId}`),
// //         apiService.get(`${config.GETMONGOLEDGERSBYID}/${bookingId}`)
// //       ]);

// //       if (invRes) setInvoices(invRes);
// //       if (ledRes) setLedgers(ledRes);
// //     } catch (error) {
// //       console.error("Error fetching accounting data:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (bookingId) {
// //       fetchAccountingData();
// //     }
// //   }, [bookingId]);

// //   return (
// //     <div id="layout-wrapper">
// //       <Header User={user} />
// //       <div className="main-content">
// //         <div className="page-content">
// //           <div className="container-fluid">
            
// //             {/* Header section */}
// //             <div className="row mb-3">
// //               <div className="col-12 d-flex justify-content-between align-items-center">
// //                 <h4 className="mb-0">Booking Accounting Details</h4>
// //                 <button className="btn btn-secondary" onClick={() => navigate(-1)}>
// //                    Back to List
// //                 </button>
// //               </div>
// //               <div className="col-12">
// //                 <p className="text-muted">Booking ID: {bookingId}</p>
// //               </div>
// //             </div>

// //             {loading ? (
// //               <div className="text-center p-5">
// //                 <div className="spinner-border text-primary" role="status"></div>
// //                 <p className="mt-2">Fetching Accounting Records...</p>
// //               </div>
// //             ) : (
// //               <>
// //                 {/* INVOICES SECTION */}
// //                 <div className="card shadow-sm mb-4">
// //                   <div className="card-header bg-soft-primary">
// //                     <h5 className="card-title mb-0">Invoices</h5>
// //                   </div>
// //                   <div className="card-body">
// //                     <div className="table-responsive">
// //                       <table className="table table-bordered align-middle">
// //                         <thead className="table-light">
// //                           <tr>
// //                             <th>Invoice No</th>
// //                             <th>Date</th>
// //                             <th>Party Name</th>
// //                             <th>Type</th>
// //                             <th className="text-end">Base Amt</th>
// //                             <th className="text-end">Tax</th>
// //                             <th className="text-end">Total</th>
// //                             <th>Status</th>
// //                           </tr>
// //                         </thead>
// //                         <tbody>
// //                           {invoices.length > 0 ? invoices.map((inv) => (
// //                             <tr key={inv.id}>
// //                               <td className="fw-medium text-primary">{inv.invoiceNumber}</td>
// //                               <td>{moment(inv.date).format("DD MMM YYYY HH:mm")}</td>
// //                               <td>{inv.partyName} <br/><small className="text-muted">{inv.partyType === 0 ? 'Customer' : 'Supplier'}</small></td>
// //                               <td>{inv.type === 0 ? <span className="badge bg-success">Sales</span> : <span className="badge bg-info">Purchase</span>}</td>
// //                               <td className="text-end">{inv.baseAmount?.toLocaleString()}</td>
// //                               <td className="text-end">{inv.taxDetails?.totalTax?.toLocaleString()}</td>
// //                               <td className="text-end fw-bold">{inv.grandTotal?.toLocaleString()}</td>
// //                               <td>{inv.status === 1 ? 'Active' : 'Cancelled'}</td>
// //                             </tr>
// //                           )) : <tr><td colSpan="8" className="text-center">No Invoices found</td></tr>}
// //                         </tbody>
// //                       </table>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 {/* LEDGERS SECTION */}
// //                 <div className="card shadow-sm">
// //                   <div className="card-header bg-soft-info">
// //                     <h5 className="card-title mb-0">Ledger Entries</h5>
// //                   </div>
// //                   <div className="card-body">
// //                     <div className="table-responsive">
// //                       <table className="table table-striped table-hover align-middle">
// //                         <thead className="table-light">
// //                           <tr>
// //                             <th>Date</th>
// //                             <th>Account Name</th>
// //                             <th>Description</th>
// //                             <th className="text-end">Debit (DR)</th>
// //                             <th className="text-end">Credit (CR)</th>
// //                           </tr>
// //                         </thead>
// //                         <tbody>
// //                           {ledgers.length > 0 ? ledgers.map((led) => (
// //                             <tr key={led.id}>
// //                               <td>{moment(led.date).format("DD MMM YYYY")}</td>
// //                               <td className="fw-medium">{led.accountName}</td>
// //                               <td className="text-muted" style={{maxWidth: '300px'}}>{led.description || '-'}</td>
// //                               <td className="text-end text-danger">{led.debit > 0 ? led.debit?.toLocaleString() : ''}</td>
// //                               <td className="text-end text-success">{led.credit > 0 ? led.credit?.toLocaleString() : ''}</td>
// //                             </tr>
// //                           )) : <tr><td colSpan="5" className="text-center">No Ledger entries found</td></tr>}
// //                         </tbody>
// //                         <tfoot className="table-light fw-bold">
// //                           <tr>
// //                             <td colSpan="3" className="text-end">Totals:</td>
// //                             <td className="text-end text-danger">
// //                               {ledgers.reduce((sum, item) => sum + item.debit, 0).toLocaleString()}
// //                             </td>
// //                             <td className="text-end text-success">
// //                               {ledgers.reduce((sum, item) => sum + item.credit, 0).toLocaleString()}
// //                             </td>
// //                           </tr>
// //                         </tfoot>
// //                       </table>
// //                     </div>
// //                   </div>
// //                 </div>
// //               </>
// //             )}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default BookingAccounting;


// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import moment from "moment";

// const BookingAccounting = () => {
//   const { bookingId } = useParams();
//   const { user } = useAuth();
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
//   const [invoices, setInvoices] = useState([]);
//   const [ledgers, setLedgers] = useState([]);

//   const fetchAccountingData = async () => {
//     setLoading(true);
//     try {
//       const [invRes, ledRes] = await Promise.all([
//         apiService.get(`${config.GETMONGOINVOICEBYID}/${bookingId}`),
//         apiService.get(`${config.GETMONGOLEDGERSBYID}/${bookingId}`)
//       ]);
//       if (invRes) setInvoices(invRes);
//       if (ledRes) setLedgers(ledRes);
//     } catch (error) {
//       console.error("Error fetching accounting data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (bookingId) fetchAccountingData();
//   }, [bookingId]);

//   // Helper for Currency Formatting
//   const formatCurr = (num) => "₹ " + (num || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//   // Separate Invoices
//   const salesInv = invoices.find(i => i.type === 0);
//   const purchaseInv = invoices.find(i => i.type === 1);

//   // Calculate Net Revenue for Summary Card
//   const netRevenue = ledgers.find(l => l.accountName === "Service Fee Income")?.credit || 0;

//   return (
//     <div id="layout-wrapper">
//       <Header User={user} />
//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
            
//             {/* Header Section */}
//             <div className="row mb-4 align-items-center">
//               <div className="col-md-6">
//                 <h4 className="mb-1 text-uppercase fw-bold">Financial Audit Log</h4>
//                 <p className="text-muted mb-0">Booking Reference: <span className="text-primary fw-medium">{bookingId}</span></p>
//               </div>
//               <div className="col-md-6 text-md-end mt-3 mt-md-0">
//                 <button className="btn btn-outline-secondary btn-label waves-effect waves-light me-2" onClick={() => navigate(-1)}>
//                   <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back
//                 </button>
//                 <button className="btn btn-primary" onClick={() => window.print()}>
//                   <i className="ri-printer-line align-middle me-1"></i> Print
//                 </button>
//               </div>
//             </div>

//             {loading ? (
//               <div className="text-center p-5 mt-5">
//                 <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}}></div>
//                 <h5 className="mt-3">Analyzing Financial Records...</h5>
//               </div>
//             ) : (
//               <>
//                 {/* --- SUMMARY CARDS --- */}
//                 <div className="row mb-4">
//                   <div className="col-md-4">
//                     <div className="card card-animate border-start border-primary border-3">
//                       <div className="card-body">
//                         <p className="text-uppercase fw-medium text-muted mb-2">Total Receivable (Agent)</p>
//                         <h4 className="mb-0">{formatCurr(salesInv?.grandTotal)}</h4>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-4">
//                     <div className="card card-animate border-start border-danger border-3">
//                       <div className="card-body">
//                         <p className="text-uppercase fw-medium text-muted mb-2">Total Payable (Supplier)</p>
//                         <h4 className="mb-0">{formatCurr(purchaseInv?.grandTotal)}</h4>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-4">
//                     <div className="card card-animate border-start border-success border-3">
//                       <div className="card-body">
//                         <p className="text-uppercase fw-medium text-muted mb-2">Net Revenue (Profit)</p>
//                         <h4 className="mb-0 text-success">{formatCurr(netRevenue)}</h4>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="row">
//                   {/* --- INVOICE DETAILS --- */}
//                   <div className="col-xl-5">
//                     <div className="card shadow-sm border-0">
//                       <div className="card-header bg-soft-info border-0">
//                         <h5 className="card-title mb-0"><i className="ri-file-list-3-line me-2"></i>Invoice Breakdown</h5>
//                       </div>
//                       <div className="card-body">
//                         {/* Sales Invoice Details */}
//                         {salesInv && (
//                           <div className="mb-4">
//                             <div className="d-flex justify-content-between align-items-center mb-2">
//                               <h6 className="fw-bold mb-0">Sales Invoice: <span className="text-primary">{salesInv.invoiceNumber}</span></h6>
//                               <span className="badge badge-soft-success">To: {salesInv.partyName}</span>
//                             </div>
//                             <div className="bg-light p-3 rounded">
//                               {salesInv.items.map((item, idx) => (
//                                 <div className="d-flex justify-content-between mb-2 small" key={idx}>
//                                   <span>{item.description}</span>
//                                   <span className="fw-medium">{formatCurr(item.rate)}</span>
//                                 </div>
//                               ))}
//                               <hr className="my-2" />
//                               <div className="d-flex justify-content-between fw-bold">
//                                 <span>Grand Total</span>
//                                 <span className="text-primary">{formatCurr(salesInv.grandTotal)}</span>
//                               </div>
//                             </div>
//                           </div>
//                         )}

//                         {/* Purchase Bill Details */}
//                         {purchaseInv && (
//                           <div>
//                             <div className="d-flex justify-content-between align-items-center mb-2">
//                               <h6 className="fw-bold mb-0">Purchase Bill: <span className="text-danger">{purchaseInv.invoiceNumber}</span></h6>
//                               <span className="badge badge-soft-danger">From: {purchaseInv.partyName}</span>
//                             </div>
//                             <div className="bg-soft-light p-3 rounded border border-dashed">
//                               <div className="d-flex justify-content-between mb-1 small">
//                                 <span>{purchaseInv.items[0]?.description}</span>
//                                 <span className="fw-medium">{formatCurr(purchaseInv.grandTotal)}</span>
//                               </div>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>

//                   {/* --- LEDGER LOG --- */}
//                   <div className="col-xl-7">
//                     <div className="card shadow-sm border-0">
//                       <div className="card-header bg-soft-dark border-0">
//                         <h5 className="card-title mb-0"><i className="ri-bank-line me-2"></i>Double-Entry Journal</h5>
//                       </div>
//                       <div className="card-body p-0">
//                         <div className="table-responsive">
//                           <table className="table table-nowrap align-middle mb-0">
//                             <thead className="table-light">
//                               <tr>
//                                 <th>Account Name</th>
//                                 <th className="text-end">Debit (Dr)</th>
//                                 <th className="text-end">Credit (Cr)</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {ledgers.map((led) => (
//                                 <tr key={led.id}>
//                                   <td>
//                                     <div className="fw-medium">{led.accountName}</div>
//                                     <div className="text-muted small">{led.description || '-'}</div>
//                                   </td>
//                                   <td className="text-end text-primary fw-medium">{led.debit > 0 ? led.debit.toFixed(2) : ""}</td>
//                                   <td className="text-end text-success fw-medium">{led.credit > 0 ? led.credit.toFixed(2) : ""}</td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                             <tfoot className="table-light fw-bold border-top">
//                               <tr>
//                                 <td className="text-center">Trial Balance Check</td>
//                                 <td className="text-end text-primary">
//                                   {formatCurr(ledgers.reduce((sum, item) => sum + item.debit, 0))}
//                                 </td>
//                                 <td className="text-end text-success">
//                                   {formatCurr(ledgers.reduce((sum, item) => sum + item.credit, 0))}
//                                 </td>
//                               </tr>
//                             </tfoot>
//                           </table>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="alert alert-info mt-3 p-2 small border-0 shadow-sm" role="alert">
//                       <i className="ri-information-line me-1"></i> Ledger entries are automatically generated from the transaction clearing account.
//                     </div>
//                   </div>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BookingAccounting;

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";

const BookingAccounting = () => {
  const { bookingId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [ledgers, setLedgers] = useState([]);

  const fetchAccountingData = async () => {
    setLoading(true);
    try {
      // API calls to your MongoAccounting endpoints
      const [invRes, ledRes] = await Promise.all([
        apiService.get(`${config.GETMONGOINVOICEBYID}/${bookingId}`),
        apiService.get(`${config.GETMONGOLEDGERSBYID}/${bookingId}`)
      ]);
      if (invRes) setInvoices(invRes);
      if (ledRes) setLedgers(ledRes);
    } catch (error) {
      console.error("Error fetching accounting data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (bookingId) fetchAccountingData();
  }, [bookingId]);

  // Helper for Currency Formatting
  const formatCurr = (num) => "₹ " + (num || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            
            {/* Header Section */}
            <div className="row mb-4 align-items-center">
              <div className="col-md-6">
                <h4 className="mb-1 text-uppercase fw-bold">Booking Invoices & Ledgers</h4>
                {/* <p className="text-muted mb-0">Booking ID: <span className="text-primary fw-medium">{bookingId}</span></p> */}
              </div>
              <div className="col-md-6 text-md-end mt-3 mt-md-0">
                <button className="btn btn-outline-secondary btn-label waves-effect waves-light me-2" onClick={() => navigate(-1)}>
                  <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back to Bookings
                </button>
                {/* <button className="btn btn-primary" onClick={() => window.print()}>
                  <i className="ri-printer-line align-middle me-1"></i> Print Statement
                </button> */}
              </div>
            </div>

            {loading ? (
              <div className="text-center p-5 mt-5">
                <div className="spinner-border text-primary" role="status" style={{width: '3rem', height: '3rem'}}></div>
                <h5 className="mt-3">Loading Accounting Records...</h5>
              </div>
            ) : (
              <div className="row">
                
                {/* 1. INVOICES SECTION (FULL WIDTH) */}
                <div className="col-12 mb-4">
                  <div className="card shadow-sm border-0">
                    <div className="card-header bg-soft-primary border-0">
                      <h5 className="card-title mb-0"><i className="ri-file-list-3-line me-2"></i>Generated Invoices</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        {invoices.length > 0 ? (
                          invoices.map((inv, idx) => (
                            <div className="col-md-6 mb-3" key={inv.id || idx}>
                              <div className={`p-3 rounded border ${inv.type === 0 ? 'border-success bg-soft-success' : 'border-info bg-soft-info'}`}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <div>
                                    <span className={`badge ${inv.type === 0 ? 'bg-success' : 'bg-info'} mb-1`}>
                                      {inv.type === 0 ? 'SALES INVOICE' : 'PURCHASE BILL'}
                                    </span>
                                    <h6 className="fw-bold mb-0">{inv.invoiceNumber}</h6>
                                  </div>
                                  <div className="text-end">
                                    <small className="text-muted d-block">{moment(inv.date).format("DD MMM YYYY")}</small>
                                    <span className="fw-bold text-dark">{formatCurr(inv.grandTotal)}</span>
                                  </div>
                                </div>
                                
                                <div className="bg-white p-2 rounded border border-light">
                                  <table className="table table-sm table-borderless mb-0">
                                    <thead>
                                      <tr className="small text-muted border-bottom">
                                        <th>Description</th>
                                        <th className="text-end">Amount</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {inv.items?.map((item, i) => (
                                        <tr key={i} className="small">
                                          <td>{item.description}</td>
                                          <td className="text-end">{formatCurr(item.taxableValue || item.rate)}</td>
                                        </tr>
                                      ))}
                                      {inv.taxDetails?.totalTax > 0 && (
                                         <tr className="small text-muted">
                                            <td>Total Tax (GST)</td>
                                            <td className="text-end">{formatCurr(inv.taxDetails.totalTax)}</td>
                                         </tr>
                                      )}
                                    </tbody>
                                    <tfoot>
                                      <tr className="fw-bold border-top">
                                        <td>Grand Total</td>
                                        <td className="text-end">{formatCurr(inv.grandTotal)}</td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                                <div className="mt-2 small">
                                  <strong>{inv.type === 0 ? 'To:' : 'From:'}</strong> {inv.partyName}
                                </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="col-12 text-center p-4">No invoices found for this booking.</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* 2. LEDGER ENTRIES SECTION (FULL WIDTH - BELOW INVOICES) */}
                <div className="col-12">
                  <div className="card shadow-sm border-0">
                    <div className="card-header bg-soft-dark border-0">
                      <h5 className="card-title mb-0"><i className="ri-bank-line me-2"></i>Ledger Entries (Double Entry)</h5>
                    </div>
                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="table table-nowrap align-middle mb-0">
                          <thead className="table-light">
                            <tr>
                              <th style={{width: '15%'}}>Date</th>
                              <th style={{width: '35%'}}>Account Details</th>
                              <th className="text-end" style={{width: '25%'}}>Debit (Dr)</th>
                              <th className="text-end" style={{width: '25%'}}>Credit (Cr)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ledgers.length > 0 ? (
                              ledgers.map((led) => (
                                <tr key={led.id}>
                                  <td className="text-muted">{moment(led.date).format("DD MMM YYYY")}</td>
                                  <td>
                                    <div className="fw-medium text-dark">{led.accountName}</div>
                                    <div className="text-muted small">{led.description || '-'}</div>
                                  </td>
                                  <td className="text-end text-primary fw-medium">
                                    {led.debit > 0 ? formatCurr(led.debit) : ""}
                                  </td>
                                  <td className="text-end text-success fw-medium">
                                    {led.credit > 0 ? formatCurr(led.credit) : ""}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center p-4">No ledger entries recorded.</td>
                              </tr>
                            )}
                          </tbody>
                          {ledgers.length > 0 && (
                            <tfoot className="table-light fw-bold border-top">
                              <tr>
                                <td colSpan="2" className="text-end">Closing Balance Check:</td>
                                <td className="text-end text-primary">
                                  {formatCurr(ledgers.reduce((sum, item) => sum + item.debit, 0))}
                                </td>
                                <td className="text-end text-success">
                                  {formatCurr(ledgers.reduce((sum, item) => sum + item.credit, 0))}
                                </td>
                              </tr>
                            </tfoot>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="alert alert-light mt-3 border-dashed" role="alert">
                    <p className="mb-0 small text-muted">
                      <i className="ri-information-line me-1"></i> 
                      Note: Invoices represent the billing document issued, while Ledger entries represent the actual accounting impact in your books of accounts.
                    </p>
                  </div>
                </div>

              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingAccounting;